<script>
import { Line } from "vue-chartjs"

export default {
  name: "LineChart",
  extends: Line,
  props: {
    chartData: Object,
    title: String,
    sizeTitle: Number,
  },
  mounted() {
    this.$nextTick(() => {
      this.renderChart(this.chartData, this.getOptions())
    })
  },
  methods: {
    getOptions: function () {
      return {
        title: {
          display: true,
          text: this.title,
          fontSize: this.sizeTitle || 16,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                callback: function (label, index, labels) {
                  return label.toLocaleString()
                },
              },
            },
          ],
        },
      }
    },
  },
  watch: {
    chartData() {
      this.$nextTick(() => {
        this.renderChart(this.chartData, this.getOptions())
      })
    },
  },
}
</script>
